<template>
  <a
    v-bind="$attrs"
    :class="cls"
    :href="href"
    :target="target"
    :rel="relType"
    v-on="$listeners"
  >
    <!--@slot Use this slot to place content inside the button.-->
    <slot />
  </a>
</template>

<script>
export default {
  name: 'TkLink',
  props: {
    target: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: 'javascript:void(0)',
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    cls() {
      if (this.type === 'button') {
        return ['btn']
      }
      return []
    },
    relType() {
      // why check target blank
      // https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
      if (
        this.target === '_blank' &&
        this.hostname !== window.location.hostname
      ) {
        return this.secureRel
      }
      return this.$attrs.rel
    },
    hostname() {
      const anchor = document.createElement('a')
      anchor.href = this.href
      return anchor.hostname
    },
    secureRel() {
      return `${this.$attrs.rel || ''} noopener noreferrer`.trim()
    },
  },
}
</script>
